import { CanDeactivate } from '@angular/router';
import { DetalleAltaComponent } from './detalle-alta.component';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';

@Injectable({ providedIn: 'root' })
export class DetalleAltaDeactivateGuard
  implements CanDeactivate<DetalleAltaComponent>
{
  async canDeactivate(component: DetalleAltaComponent): Promise<boolean> {
    if (!component.editandoCredenciales) {
      return true;
    }

    const confirm = await Swal.fire({
      title: '¿Estás seguro?',
      text: 'Si abandonas la página perderás los cambios realizados',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, salir',
      cancelButtonText: 'No, quedarme',
    });

    return confirm.isConfirmed;
  }
}
